import { carouselInit } from '../main/carousel'
class QuickModal extends HTMLElement {
  constructor () {
    super()

    // Gets the quick modal overlay and inserts into the correct position if popup style is not selected
    if (this.getAttribute('quick-modal-style')) {
      const quickModalOverlay = this.querySelector('.card__quick-shop-overlay')
      const quickModalStyle = this.getAttribute('quick-modal-style')
      const cardContainer = this.closest('.card__container')
      if (quickModalStyle === 'image_overlay') {
        // Places the quick modal overlay above the card image
        if (!cardContainer.querySelector('.card__overlay-wrapper')) {
          cardContainer.querySelector('.card__image-wrapper').prepend(quickModalOverlay)
        } else {
          cardContainer.querySelector('.card__overlay-wrapper').prepend(quickModalOverlay)
        }
        const quickModalButton = this.querySelector('.card__quick-shop-btn')
        const closeOverlayButton = quickModalOverlay.querySelector('.card__quick-shop-overlay-close')

        quickModalButton.addEventListener('click', () => quickModalOverlay.classList.remove('hidden'))
        closeOverlayButton.addEventListener('click', () => quickModalOverlay.classList.add('hidden'))
      } else if (quickModalStyle === 'card_overlay') {
        // Places the quick modal overlay above the card
        cardContainer.prepend(quickModalOverlay)
        const quickModalButton = this.querySelector('.card__quick-shop-btn')
        const closeOverlayButton = quickModalOverlay.querySelector('.card__quick-shop-overlay-close')

        quickModalButton.addEventListener('click', () => quickModalOverlay.classList.remove('hidden'))
        closeOverlayButton.addEventListener('click', () => quickModalOverlay.classList.add('hidden'))
      }
    } else {
      // Initiates quick shop popup modal
      const quickModalButton = this.querySelector('.card__quick-shop-btn')
      quickModalButton.addEventListener('click', this.clickQuickModalButton)
    }
  }

  clickQuickModalButton (e) {
    e.preventDefault()
    const productHandle = this.parentElement.getAttribute('product-handle')
    const shopLocaleDefault = this.parentElement.getAttribute('shop-locale-default')
    const shopLocale = this.parentElement.getAttribute('shop-locale')
    let fetchPath = ''
    if (shopLocale === shopLocaleDefault) {
      fetchPath = `/products/${productHandle}`
    } else {
      fetchPath = `/${shopLocale}/products/${productHandle}`
    }
    if (productHandle) {
      fetch(fetchPath)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const section = doc.querySelector('.template-product')
          const productError = window.quickModalStrings.productError
          this.parentElement.querySelector('.card__quick-shop-content').innerHTML = section ? section.innerHTML : productError
          const dialog = this.parentElement
          if (dialog) {
            document.body.classList.add('overflow-hidden')
            dialog.querySelector('.template-product__spacing').setAttribute('style', 'padding-left:0;padding-right:0;')
            dialog.querySelector('.product__media').setAttribute('style', 'margin-left:0;margin-right:0;')
            dialog.querySelector('.product__info').classList.remove('self-start')
            dialog.querySelector('dialog').showModal()
            dialog.classList.add('atc__unfinished')
            const handleClassChange = () => {
              if (!dialog.classList.contains('atc__unfinished')) {
                document.body.classList.remove('overflow-hidden')
                dialog.querySelector('dialog').close()
                observer.disconnect()
              }
            }
            const observer = new MutationObserver(handleClassChange)
            observer.observe(dialog, { attributes: true })
            carouselInit()

            if (document.querySelector('.flexible-bundle-groups')) {
              const priceNode = dialog.querySelector('.product-price')
              const taxNode = dialog.querySelector('#shipping_policy')
              const shippingDateNode = dialog.querySelector('.product__date-container')
              const variantSelectorNode = dialog.querySelector('.product-variant-selector')
              const quantityPicker = dialog.querySelector('.quantity-picker')
              const productFormNode = dialog.querySelector('.product-form-cntr')
              // Remove unwanted nodes for flexible bundles
              priceNode?.parentNode.removeChild(priceNode)
              taxNode?.parentNode.removeChild(taxNode)
              shippingDateNode?.parentNode.removeChild(shippingDateNode)
              variantSelectorNode?.parentNode.removeChild(variantSelectorNode)
              quantityPicker?.parentNode.removeChild(quantityPicker)
              productFormNode?.parentNode.removeChild(productFormNode)

              // When limited line-height for product-description block is enabled, the pdp page loads with the setting of flexible bundle page, not of pdp
              // Adjust styling to match inside text height
              dialog.querySelector('.product-description').classList.replace('product-description', 'product-description-quick-modal')
            }
          }
        })
        .catch(error => {
          console.error('Error loading product:', error)
        })
    }
  }
}

customElements.define('quick-modal', QuickModal)
